module.exports = __webpack_public_path__ + "assets/img/footer-warn.5de89750.png";